export enum SearchType {
    Category = "Category",
    Search = "Search"
}